
export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken },
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;

        let sessionSystemUserChaildId = sessionStorage.getItem(
          "currentTabChaildId"
        );

        if (sessionSystemUserChaildId != null) {
          config.headers.systemuserchildid = sessionSystemUserChaildId;
        }
      }

      return config;
    },
    (err) => Promise.reject(err)
  );
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      // whatever you want to do with the error

      if (error.response.status == 401) {
        window.location.replace("/logout");
      }

      return Promise.reject(error);
    }
  );
}
